const autoNgTemplateLoaderTemplate1 = require('./applicationsPortsDatatable.html');

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationsPortsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationsPortsDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
